import React from 'react'
// début de modification Kani
import ReactEcharts from "echarts-for-react";
// fin de modification Kani

/*
import {
    XAxis,
    VerticalGridLines,
    HorizontalBarSeries,
    FlexibleXYPlot,
    LabelSeries
  } from "react-vis";
*/

function GrapheIR1({dataIR1}) {
    // début de modification Kani
    const option = {
        animation: false,
        grid: { left: 20, right: 80, top: 10, bottom: 30, containLabel: true },
        xAxis: {
            type: "value",
            splitLine: { lineStyle: { color: "#C6C6C6" } },
            axisLabel: { color: "#000" },
        },
        yAxis: {
            type: "category",
            data: dataIR1.map((d) => d.y),
            axisLabel: { show: false }, // 👈 masque uniquement les nombres
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { lineStyle: { color: "#C6C6C6" } }, // 👈 lignes grises conservées
        },
        series: [
            {
                type: "bar",
                barWidth: "90%",
                label: {
                    show: true,
                    position: "right",
                    formatter: (params) => params.value + " €",
                    color: "#000",
                },
                data: dataIR1.map((d) => ({
                    value: d.x,
                    itemStyle: { color: d.color || "#5470C6" },
                })),
            },
        ],
    };

    return (
        <div style={{ marginLeft: "-50px" }}>
            <ReactEcharts option={option} style={{ width: "600px", height: "300px" }} />
        </div>
    );
    // fin de modification Kani

    /*
    const labelData = dataIR1.map((d) => ({ x: d.x, y: d.y }));
    return (
        <div style={{marginLeft:"-50px"}}>
            <FlexibleXYPlot  width={600} height={300}  colorType="literal" >
                <VerticalGridLines  style={{stroke: '#C6C6C6'}}  />
                <XAxis />
                <HorizontalBarSeries stroke={'transparent'}  data={dataIR1} barWidth={0.9} />
                <LabelSeries data={labelData} getLabel={d => d.x + ' €'} />
            </FlexibleXYPlot>
        </div>
    );
    */
}

export default GrapheIR1